const apiUrl = process.env.REACT_APP_API_URL;

export const getPhilippinesDate = () => {
    const options = {
        timeZone: 'Asia/Manila',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    };

    const formatter = new Intl.DateTimeFormat('en-PH', options);
    return formatter.format(new Date());
};

const generateListId = () => {
    const datePart = getPhilippinesDate().replaceAll('/', '');
    const randomPart = Math.floor(1000 + Math.random() * 9000);

    return `LST${datePart}${randomPart}`;
};

export const getNewListId = async () => {
    let listId;
    let isUnique = false;

    while (!isUnique) {
        listId = generateListId();

        try {

            const response = await fetch(
                `${apiUrl}validation/validate_list_id.php`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ listId }),
                });

            const data = await response.json();
            isUnique = data.unique;

        } catch (error) {
            console.error('Error validating list number:', error);
            break;
        }
    }

    return listId;
};